<template>
  <BaseDialog
    contentClass="profile-field-template"
    ref="dialog"
    :show-actions="true"
    sidePanel
    white-content
    @closeModal="closeDialog"
  >
    <template slot="title">
      {{
        isEdit
          ? $t('page.admin-tenant-profile.template-dialog.edit')
          : $t('page.admin-tenant-profile.template-dialog.new')
      }}
    </template>
    <template slot="content">
      <form @submit.prevent="onSubmit" novalidate class="profile-field-template__form">
        <FormInput
          ref="nameInput"
          :label="$t('page.admin-tenant-profile.template-dialog.name-label')"
          has-gray-background
          name="templateName"
          isRequired
          v-model="name"
        />
        <FormCheckbox
          v-if="!isEdit"
          class="profile-field-template__default"
          :value="isDefault"
          :label="$t('page.admin-tenant-profile.template-dialog.set-default')"
          @input="isDefault = $event"
        />
        <div class="profile-field-template__actions">
          <BaseButton is-large type="submit" :disabled="!name.trim()" :is-outlined="!name.trim()">
            {{ isEdit ? $t('actions.save') : $t('page.admin-tenant-profile.add-template') }}
          </BaseButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseDialog from '@/components/base/BaseDialog';
import FormInput from '@/components/form/FormInput.vue';
import FormCheckbox from '@/components/form/FormCheckbox.vue';

export default {
  name: 'ProfileFieldTemplateDialog',
  components: { BaseButton, BaseDialog, FormInput, FormCheckbox },
  data() {
    return { name: '', templateId: null, isDefault: false };
  },
  computed: {
    isEdit() {
      return !!this.templateId;
    },
  },
  methods: {
    openAdd() {
      this.name = '';
      this.templateId = null;
      this.isDefault = false;
      this.$refs.dialog.openModal();
    },
    openEdit(template) {
      this.name = template.name;
      this.templateId = template.id;
      this.isDefault = !!template.isDefault;
      this.$refs.dialog.openModal();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      const name = this.name.trim();
      if (!name) return;
      this.$emit('submit', {
        mode: this.isEdit ? 'edit' : 'add',
        templateId: this.templateId,
        name,
        isDefault: this.isDefault,
      });
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__profile-field-template {
  .profile-field-template__actions {
    display: flex;
    justify-content: center;
    padding-top: $space-xl;
  }
  .profile-field-template__default {
    margin-top: $space-sm;
  }
}
</style>
